import { Component, OnInit } from '@angular/core';
import { DefaultComponentsModule } from 'app/shared/modules/default-components.module';
import { useMenuTracking } from 'app/shared/hooks';

@Component({
  selector: 'app-aulas-ao-vivo',
  imports: [DefaultComponentsModule],
  templateUrl: './aulas-ao-vivo.component.html',
  styleUrl: './aulas-ao-vivo.component.scss'
})
export class AulasAoVivoComponent implements OnInit {
  private menuTracking = useMenuTracking();

  ngOnInit(): void {
    this.menuTracking.registrarAcessoMenu('aulas-ao-vivo');
  }
}
